export default __webpack_public_path__ + "static/image04-f4c60eba070a64019a1a3e9dc615a475.webp";